export const headCells = [
  {
    id: 'taskName',
    numeric: false,
    disablePadding: false,
    disableSort: false,
    label: 'Название задачи',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Статус',
  },
  {
    id: 'nextRunDate',
    numeric: false,
    disablePadding: false,
    disableSort: false,
    label: 'Дата следующего запуска',
    style: { maxWidth: '100px' },
  },
  {
    id: 'lastRunDate',
    numeric: false,
    disablePadding: false,
    disableSort: false,
    label: 'Дата последнего запуска',
  },
  {
    id: 'schedule',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Расписание',
  },
  {
    id: 'createdBy',
    numeric: false,
    disablePadding: false,
    disableSort: false,
    label: 'Автор',
  },
];

export const displayedCells = ['taskName', 'status', 'nextRunDate', 'lastRunDate', 'schedule', 'createdBy'];
